import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { X, Plus, Minus, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartDrawer = () => {
  const { items, drawerOpen, setDrawerOpen, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();

  return (
    <>
      {drawerOpen && <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm" onClick={() => setDrawerOpen(false)} />}
      <aside
        className={`fixed right-0 top-0 bottom-0 z-50 w-full sm:w-[420px] bg-[#faf7f1] shadow-2xl flex flex-col transition-transform duration-500 ease-in-out ${drawerOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex items-center justify-between p-6 border-b border-[#e5decf]">
          <div className="font-serif-elegant text-2xl">Your Cart</div>
          <button onClick={() => setDrawerOpen(false)} aria-label="Close" className="hover:opacity-70"><X className="w-5 h-5" /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {items.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <ShoppingBag className="w-14 h-14 text-[#7a8b6b] mb-4" />
              <div className="font-serif-elegant text-2xl mb-2">Your cart is quiet</div>
              <p className="text-sm text-[#6f6a5f] mb-6">Add a little wellness to it.</p>
              <Link to="/collections/all" onClick={() => setDrawerOpen(false)} className="btn-primary">Shop Now</Link>
            </div>
          ) : (
            <ul className="space-y-6">
              {items.map(item => (
                <li key={item.lineId} className="flex gap-4">
                  <img src={item.image} alt={item.title} className="w-24 h-24 object-cover" />
                  <div className="flex-1">
                    <div className="font-medium text-sm mb-1">{item.title}</div>
                    <div className="text-sm text-[#7a8b6b] mb-3">${item.price.toFixed(2)}</div>
                    {item.extras?.deliverTo && (
                      <div className="text-xs text-[#6f6a5f] mb-2">To: {item.extras.deliverTo}</div>
                    )}
                    <div className="flex items-center gap-3">
                      <div className="flex items-center border border-[#c9c1ad]">
                        <button onClick={() => updateQty(item.lineId, item.qty - 1)} className="p-1.5 hover:bg-[#efe9db]"><Minus className="w-3 h-3" /></button>
                        <span className="px-3 text-sm">{item.qty}</span>
                        <button onClick={() => updateQty(item.lineId, item.qty + 1)} className="p-1.5 hover:bg-[#efe9db]"><Plus className="w-3 h-3" /></button>
                      </div>
                      <button onClick={() => removeItem(item.lineId)} className="text-xs uppercase tracking-widest text-[#6f6a5f] hover:text-[#7a3b2e] transition-colors">Remove</button>
                    </div>
                  </div>
                  <div className="text-sm font-medium">${(item.price * item.qty).toFixed(2)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-[#e5decf] p-6 space-y-4">
            <div className="flex justify-between text-sm">
              <span className="uppercase tracking-widest text-xs">Subtotal</span>
              <span className="font-medium">${subtotal.toFixed(2)}</span>
            </div>
            <p className="text-xs text-[#6f6a5f]">Shipping &amp; taxes calculated at checkout.</p>
            <div className="grid grid-cols-2 gap-3">
              <button onClick={() => { setDrawerOpen(false); navigate('/cart'); }} className="btn-outline w-full">View Cart</button>
              <button onClick={() => { setDrawerOpen(false); navigate('/cart'); }} className="btn-primary w-full">Checkout</button>
            </div>
          </div>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
